import type { ShareAction } from '#src/app/shared/hooks/share';

import { useMobileNativeShare } from './useMobileNativeShare';

type UsePetitionHeadingMobileReturn = ModelHookResult<{
	shareAction: ShareAction<'mobileNativeShare'> | null;
}>;

export function usePetitionHeadingMobile(): UsePetitionHeadingMobileReturn {
	const shareAction = useMobileNativeShare();

	return {
		data: {
			shareAction,
		},
	};
}
